import React from 'react';
import { MailCheck } from 'lucide-react';
import SuperAdminProvisionForm from '../../components/superadmin/SuperAdminProvisionForm';
import { PageHeader } from '../../components/superadmin/SuperAdminUI';

const SuperAdminProvisionPage = () => {
  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Provisioning"
        title="Provision Admin Accounts"
        description="Create a shop admin, open a controlled trial window, add credits, and trigger the token-based onboarding email from the isolated Super Admin flow."
        action={
          <div className="inline-flex items-center gap-2 rounded-full border border-emerald-200 bg-emerald-50/80 px-4 py-2 text-sm font-medium text-emerald-700 dark:border-emerald-800 dark:bg-emerald-900/20 dark:text-emerald-300">
            <MailCheck className="h-4 w-4" />
            <span>Token-based onboarding</span>
          </div>
        }
      />
      <SuperAdminProvisionForm />
    </div>
  );
};

export default SuperAdminProvisionPage;
